export default "https://cdn-static.gokick.com/assets/76516c8a60965c2814adf9f2d5cc0638cda6ee5d/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";